import React from "react";
import { styled } from "@mui/material/styles";
import { FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material";

// Custom Styled Select
const WhiteBorderSelect = styled(FormControl)(({
  theme
}) => ({
  "& .MuiInputLabel-root": {
    color: "#6f7d83",
    fontWeight: "bold" // Match TextField label
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "var(--text_secondary_light) !important"
  },
  "& .MuiOutlinedInput-root": {
    // backgroundColor: "inherit", // Match TextField background
    borderRadius: "10px",
    "& fieldset": {
      borderColor: "#c2cdd1" // Match TextField border color
    },
    "&:hover fieldset": {
      borderColor: "#ff9800" // Hover color
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ff9800" // Focus color
    }
  }
}));
const UtsavSelect = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  error,
  errorMessage
}) => {
  return <>
      <WhiteBorderSelect variant="outlined" fullWidth sx={{
      mt: "15px"
    }} data-sentry-element="WhiteBorderSelect" data-sentry-source-file="UtsavSelect.jsx">
        <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="UtsavSelect.jsx">{label}</InputLabel>
        <Select value={value} onChange={onChange} label={label} disabled={disabled} inputProps={{
        style: {
          borderRadius: "10px"
        }
      }} data-sentry-element="Select" data-sentry-source-file="UtsavSelect.jsx">
          {options.map((option, index) => <MenuItem key={index} value={option}>
              {option}
            </MenuItem>)}
        </Select>
      </WhiteBorderSelect>
      {error && <Typography sx={{
      color: "red"
    }}>{errorMessage}</Typography>}
    </>;
};
export default UtsavSelect;